module.exports = __webpack_public_path__ + "static/media/coin-icon.02b7cd20.png";